import { useEffect, useState } from "react";
import Cards from "../../../components/common/card/Card";
import TopSection from "../TopSection";
import "./ActionDashboard.css";
import { useMsal } from "@azure/msal-react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { useDispatch, useSelector } from "react-redux";
import { getActionDashboardCount } from "../../../redux/actions/LTPlanner/ActionDashboardSlice";
import { actionDashboardEndpoint } from "../../../common/endpoints";
import { Loader } from "../../../components/common/Loader";
import { getPowerBIActionDashboardData } from "../../../redux/actions/LTPlanner/PowerBIActionDashboardSlice";
import { toast } from "react-toastify";

const ActionDashboard = () => {
  const dispatch = useDispatch();
  const userEmail = localStorage.getItem("data");
  const ActionDashboardSlice = useSelector((state) => state?.ActionDashboardSlice);
  const [countData, setCountData] = useState();
  const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
  const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
  const [powerBIReportID, setPowerBIReportID] = useState("");
  localStorage.setItem("workflowActiveItem", "Pending Action");
  localStorage.setItem("activeCard", 0);
  const { accounts } = useMsal();

  const group_id = process.env.REACT_APP_PBI_ACTION_DASHBOARD_GROUP_ID;
  const report_id = process.env.REACT_APP_PBI_ACTION_DASHBOARD_REPORT_ID;

  useEffect(() => {
    if (accounts.length) {
      const fetchData = async () => {
        try {
          const responseCount = await dispatch(getActionDashboardCount({
            dynamicEndpoint: `${actionDashboardEndpoint}/${userEmail}`,
            params: {
              plant: localStorage.getItem("selectedLTPlantCode")
            }
          }));
          if (responseCount.meta.requestStatus === 'fulfilled') {
            setCountData(responseCount?.payload);
          } else {
            console.error('Failed to fetch data:', responseCount.error);
            toast.error(responseCount?.payload?.errorMessage, {
              autoClose: 2000,
            });

          }
        } catch (error) {
          console.error('API error:', error);
          toast.error(error, {
            autoClose: 2000,
          });
        }
      }

      fetchData();
    } else {
      console.log("No accounts exist to get access token");
    }
  }, [])

  useEffect(() => {
    const getPowerBIActionDashboardDetails = async () => {
      try {
        const responsePowerBIActionDashboardDetails = await dispatch(getPowerBIActionDashboardData({
          dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          }
        }));
        if (responsePowerBIActionDashboardDetails?.meta?.requestStatus === 'fulfilled') {
          setPowerBIEmbedURL(responsePowerBIActionDashboardDetails?.payload?.embedUrl);
          setPowerBIReportID(responsePowerBIActionDashboardDetails?.payload?.reportId);
          setPowerBIAccessToken(responsePowerBIActionDashboardDetails?.payload?.accessToken)
        } else {
          toast.error(responsePowerBIActionDashboardDetails?.payload?.errorMessage, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error('API error:', error);
        toast.error(error, {
          autoClose: 2000,
        });
      }
    }
    getPowerBIActionDashboardDetails();

  }, []);


  const filter = [
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Supplier",
        column: "SUPPLIER",
      },
      operator: "In",
      values: countData?.topFiveSuppliers,
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Material",
        column: "MATERIAL_POITEM",
      },
      operator: "In",
      values: countData?.topFiveMaterials,
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Input",
        column: "PLANT_POITEM",
      },
      operator: "Equals",
      values: [localStorage.getItem("selectedLTPlantCode")],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
  ];

  const embedConfig = {
    type: 'report',
    id: powerBIReportID,
    embedUrl: `${powerBIEmbedURL}`,
    accessToken: powerBIAccessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth,
      },
    },
    filters: filter
  }


  const cardData = [
    {
      title: "High LT Variation",
      description: "",
      value: countData?.highLt,
      url: "/analytics-results"
    },
    { title: "Medium LT Variation", value: countData?.mediumLt, url: "/analytics-results" },
    { title: "Low LT Variation", value: countData?.lowLt, url: "/analytics-results" },
  ];

  return (
    ActionDashboardSlice?.loading ?
      <Loader />
      :
      <div>
        <TopSection
          labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "LT Dashboard" },
          ]}
          tabTitle="Dashboard"
        />
        <div className="container">
          <Cards cards={cardData} showBorder={false} />
        </div>
        {/* <div style={{ margin: "10px 0px", textAlign: "center" }}>
          <iframe title="LTVariations1" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=84d12ae1-f150-4c18-b69a-6a512cbdceb7&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c&navContentPaneEnabled=false" frameborder="0" allowFullScreen="true"></iframe>
        </div> */}
        <div className="powerBi_cls">
          {embedConfig?.embedUrl && embedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={embedConfig}
            />}
        </div>
      </div>
  );
};

export default ActionDashboard;
